// Cor de tag calculada por hash — determinística (a mesma tag sempre sai com a mesma cor),
// sem persistir nada no banco nem precisar de tela de "gerenciar tags da empresa". Mesmo
// espírito da paleta fixa já usada em CORES_SUGERIDAS (CrmBoardView.tsx).
const PALETA = ['#6b7280', '#3b82f6', '#a855f7', '#f59e0b', '#22c55e', '#ef4444', '#ec4899', '#14b8a6'];

export function tagColor(tag: string): string {
  let hash = 0;
  for (let i = 0; i < tag.length; i++) {
    hash = (hash + tag.charCodeAt(i)) % PALETA.length;
  }
  return PALETA[hash];
}
